export default "__VITE_ASSET__BhR_qMZs__"